import { h } from 'vue';
import { frontendURL } from '../../../../helper/URLHelper';
import SettingsWrapper from '../SettingsWrapper.vue';
import Index from './Index.vue';
import FeatureGatedPage from 'dashboard/components/pipelines/FeatureGatedPage.vue';

const gated = (feature, component) => ({
  render: () => h(FeatureGatedPage, { feature }, { default: () => h(component) }),
});

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/deal-loss-reasons'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'deal_loss_reasons_wrapper',
          meta: { permissions: ['administrator'] },
          redirect: to => {
            return { name: 'deal_loss_reasons_list', params: to.params };
          },
        },
        {
          path: 'list',
          name: 'deal_loss_reasons_list',
          meta: { permissions: ['administrator'] },
          component: gated('pipeline', Index),
        },
      ],
    },
  ],
};
